import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  phone: '',
  city: '',
  status: '',
  avatar: '',
  authorized: false,
  userLoading: false,
  editorLoading: false,
  users: [],
  page: '0',
  size: '10',
  sort: '',
  search: '',
  totalCount: '',
  singleUser: [],
  csvBase64: '',
  formMode: 'add',
  selectedRowKeys: [],
  roles: [],
  isUserModalUnassignVisible: false,
  multiUserAssignRole: '',
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
